export function spacesDropDownList(spaces) {
  return [...Array(spaces).keys()].map((n) => {
    return { id: n + 1, title: n + 1 }
  });
}
